export function isPititimAvailable(unit) {
  return unit !== "POUSO_ALEGRE";
}
